import { Grid } from '@material-ui/core';
import localforage from 'localforage';
import React, { useEffect, useState } from 'react';

import type { SignAndStampFile } from '../../rxdb/signAndStamp/signAndStamp.types';
import { useFileStorage } from '../../utilities/useFileStorage';

localforage.createInstance({
  name: 'attachment-store',
});

interface Props {
  data?: SignAndStampFile;
  altText: string;
}

const SignAndStampImageView: React.FC<Props> = ({ data, altText = 'Sign' }) => {
  const { fileUUID } = data as SignAndStampFile;
  const { getAttachmentFromIndexDB } = useFileStorage();
  const [imageURL, setImageURL] = useState('');

  const getS3URL = async (fileId: string) => {
    const blobFile: Blob = (await getAttachmentFromIndexDB(fileId)) as Blob;
    const url = blobFile ? URL.createObjectURL(blobFile) : '';
    setImageURL(url);
    return url;
  };

  useEffect(() => {
    if (fileUUID) getS3URL(fileUUID);
  }, [fileUUID]);

  return (
    <Grid>
      <img width="150px" height="150px" src={imageURL} alt={altText} />
    </Grid>
  );
};

export default SignAndStampImageView;
